import { Avatar } from "@mui/material";
import Box from "@mui/material/Box";
import { blue, teal } from "@mui/material/colors";
import React from "react";
import botIcon from "../../src/public/bot.png";
import { useCustomThemeContext } from "../lib/contexts/ThemeContext";
import { Message } from "../lib/interfaces/Chat";
import LinkCreator from "./linkCreator";
import SourcesAccordion from "./sourcesAccordion";
import SourcesLoadingState from "./sourcesLoadingState";
import ReactMarkdown from "react-markdown";

interface ChatBubbleProps {
  index: number;
  message: Message;
  previousMessage: Message;
  chatId: string;
  isLoadingSources?: boolean;
}

function ChatBubble(props: ChatBubbleProps) {
  const { custom } = useCustomThemeContext();
  
  const containsSources =
    props.message?.sources && Object.keys(props.message.sources).length > 0;
  const sources = containsSources ? props.message.sources : null;
  const message = props.message?.message || '';

  return (
    <Box
      key={props.index}
      style={{
        display: "flex",
        justifyContent: "left",
        alignItems: "center",
        textAlign: "left",
        padding: "20px 0",
        width: "95%",
      }}
    >
      {/** If the message is from the user, render their avatar. Otherwise, render FA's avatar */}
      {props.message.fromUser ? (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Avatar
            variant="square"
            sx={{
              bgcolor: teal[800],
              marginRight: "20px",
              fontSize: "0.7em",
              borderRadius: "5px",
              padding: "2px",
              fontWeight: 550,
            }}
          >
            USER
          </Avatar>
        </Box>
      ) : (
        <Avatar
          variant="square"
          sx={{
            bgcolor: blue[900],
            marginRight: "20px",
            fontSize: "0.6em",
            borderRadius: "5px",
            padding: "2px",
          }}
        >
          <img
            src={botIcon}
            alt="botIcon"
            style={{ width: "25px", height: "25px" }}
          />
        </Avatar>
      )}

      <Box
        sx={{
          width: "100%",
          padding: "20px",
          marginRight: "30px",
          borderRadius: "10px",
          background: props.message.fromUser //making the background of the message white if it's from FA's bot
            ? custom.palette.primary.main
            : "white",
        }}
      >
        <Box sx={{ marginBottom: "1vh" }}>
          {props.message.fromUser
            ? (message && <LinkCreator line={message} />)
            : (message && (
                // Render markdown for bot messages
                <ReactMarkdown
                  children={message}
                  components={{
                    a: ({node, ...props}) => <LinkCreator line={props.href || ""} {...props} />
                  }}
                />
              ))
          }
        </Box>

        {!props.message.fromUser && (
          <>
            {sources && <SourcesAccordion sources={sources} />}
            {props.isLoadingSources && !sources && <SourcesLoadingState />}
          </>
        )}
      </Box>
    </Box>
  );
}

export default React.memo(ChatBubble);
